import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=04d04d4b&scoped=true&"
import script from "./Sensor.vue?vue&type=script&lang=js&"
export * from "./Sensor.vue?vue&type=script&lang=js&"
import style0 from "./Sensor.vue?vue&type=style&index=0&id=04d04d4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d04d4b",
  null
  
)

export default component.exports